import React, { useState, useRef, useEffect } from 'react';
import './LayerSelector.css';

export interface LayerOption {
    id: string;
    name: string;
    icon: string;
    url: string;
    attribution: string;
    minZoom?: number;
    maxZoom?: number;
    tileSize?: number;
}

interface LayerSelectorProps {
    layers: LayerOption[];
    selectedLayer: string;
    onLayerChange: (layerId: string) => void;
}

const LayerSelector: React.FC<LayerSelectorProps> = ({ layers, selectedLayer, onLayerChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectorRef = useRef<HTMLDivElement>(null);

    const currentLayer = layers.find(layer => layer.id === selectedLayer);

    // Fermer le menu quand on clique en dehors
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (selectorRef.current && !selectorRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLayerClick = (layerId: string) => {
        onLayerChange(layerId);
        setIsOpen(false);
    };

    return (
        <div className="layer-selector" ref={selectorRef}>
            <button
                className="layer-selector-button"
                onClick={() => setIsOpen(!isOpen)}
                title="Sélectionner une couche"
            >
                <span className="layer-icon">{currentLayer?.icon || '🗺️'}</span>
            </button>

            {isOpen && (
                <div className="layer-selector-menu">
                    {layers.map((layer) => (
                        <button
                            key={layer.id}
                            className={`layer-option ${selectedLayer === layer.id ? 'selected' : ''}`}
                            onClick={() => handleLayerClick(layer.id)}
                        >
                            <span className="layer-icon">{layer.icon}</span>
                            <span className="layer-name">{layer.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LayerSelector;
